import React, { JSX } from 'react';
import { Text } from '@chakra-ui/react';

import { formatWeekRange } from '../utils/metrics';

interface Props {
  weekNumber: number;
  weekStart: string;
  weekEnd: string;
}

const ChartTooltipHeader = ({ weekNumber, weekStart, weekEnd }: Props): JSX.Element => (
  <>
    <Text fontSize="xs" fontWeight="bold">
      CW {weekNumber}
    </Text>
    <Text fontSize="xs" color="grey.200" mb={1}>
      {formatWeekRange(weekStart, weekEnd)}
    </Text>
  </>
);

export default ChartTooltipHeader;
